import React, { useEffect, useMemo, useState } from 'react';
import Header from '../../../../../customer-landing/components/Header';
import CustomerCustomPageContent from '../../../../../customer-landing/components/custom-pages/CustomerCustomPageContent';
import StorefrontPoweredByFooter from '../../../../../customer-landing/components/storefront-powered-by-footer/StorefrontPoweredByFooter';
import StorefrontServiceSection from '../../../../../customer-landing/components/storefront/StorefrontServiceSection';
import { StorefrontAuthProvider } from '../../../../../customer-landing/auth/context/StorefrontAuthContext';
import { fetchStorefrontServices } from '../../../../../customer-landing/storefront-booking/storefrontServicesCache';
import {
  getLandingPageCustomStyles,
  getLandingPageServiceListingStyle
} from '../../../../../customer-landing/utils/landingPageTheme';
import '../../../../../customer-landing/styles/LandingPage.css';

const PREVIEW_SAMPLE_SERVICES = [
  {
    id: 'preview-service-1',
    name: 'Sample Service',
    description: 'Your published services will appear here.',
    duration: 45,
    price: 75
  },
  {
    id: 'preview-service-2',
    name: 'Another Service',
    description: 'Preview uses your real services when available.',
    duration: 60,
    price: 95
  },
  {
    id: 'preview-service-3',
    name: 'Consultation',
    description: 'Adjust layout and colors to match your brand.',
    duration: 30,
    price: 50
  }
];

const PreviewHomeContent = ({ companyData }) => {
  const [services, setServices] = useState(PREVIEW_SAMPLE_SERVICES);
  const serviceListingStyle = getLandingPageServiceListingStyle(companyData?.landingPageSettings);

  useEffect(() => {
    if (!companyData?.id) {
      return undefined;
    }

    let cancelled = false;

    fetchStorefrontServices(companyData.id)
      .then((nextServices) => {
        if (!cancelled && Array.isArray(nextServices) && nextServices.length > 0) {
          setServices(nextServices);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [companyData?.id]);

  return (
    <StorefrontServiceSection
      services={services}
      serviceListingStyle={serviceListingStyle}
      onServiceClick={() => {}}
    />
  );
};

const PreviewCustomPageContent = ({ companyData, page }) => {
  if (!page || page.isVisible === false) {
    return (
      <section className="services-section">
        <div className="container">
          <div className="error-container">
            <h2>Page unavailable</h2>
            <p>The page you requested could not be found.</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="services-section">
      <div className="container">
        <CustomerCustomPageContent companyData={companyData} page={page} />
      </div>
    </section>
  );
};

const StorefrontBuilderPreview = ({
  companyData,
  companyUrl = 'preview',
  previewPageId = 'home',
  pages = [],
  onPreviewPageChange = () => {}
}) => {
  const slug = (companyUrl || 'preview').trim() || 'preview';
  const customStyles = useMemo(
    () => getLandingPageCustomStyles(companyData?.landingPageSettings),
    [companyData?.landingPageSettings]
  );
  const activePage = previewPageId === 'home'
    ? null
    : pages.find((entry) => entry.id === previewPageId) || null;

  return (
    <div className="ce-preview__frame ce-preview__frame--storefront">
      <div className="landing-page ce-preview-landing-page" style={customStyles}>
        <StorefrontAuthProvider companyData={companyData}>
          <Header
            companyData={companyData}
            previewMode
            previewCompanyUrl={slug}
            previewPageId={previewPageId}
            onPreviewNavigate={onPreviewPageChange}
          />
          {previewPageId === 'home' ? (
            <PreviewHomeContent companyData={companyData} />
          ) : (
            <PreviewCustomPageContent companyData={companyData} page={activePage} />
          )}
          <StorefrontPoweredByFooter />
        </StorefrontAuthProvider>
      </div>
    </div>
  );
};

export default StorefrontBuilderPreview;
